export default "__VITE_ASSET__z2W4Q1oJ__"